var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130.06 72.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.7,30.4V45.1H18V71.5H0V0H53.2V14.7H18V30.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.77,36.35h10.57A90,90,0,0,0,119.51,35q-5.85,7-11,7l-4.21-.1-4.79-.1-3.82-.1H93.13l-.35,3.6-.49,4.34q-.83,7-3,10.09c-1.45,2.08-4.27,4.11-8.43,6.09l13.61.74-5.89,5.72L65.22,71.17l6.36-6.11,5.32.59q6-3.8,7.4-15.54l.54-4.83,3.89-35.11H87.06q-9.57,0-15,3.92a12.51,12.51,0,0,0-5.45,10.72,17.8,17.8,0,0,0,2.27,8.39l-8,7.69a26.28,26.28,0,0,1-1.14-7.5q0-13.8,11.49-22.34Q79.61,4.84,95,4.84h16.33q9.16,0,18.69-.69l-4,10.14-.79,1.83Q124.09,19,122.17,19a4.84,4.84,0,0,1-.74-.05,18.61,18.61,0,0,0,.59-3.94q0-3.25-3.46-4.07t-17.14-.81H96.67Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrand);
export default __webpack_public_path__ + "static/media/brand.80261f114da49e42a5ed8aa6844c951b.svg";
export { ForwardRef as ReactComponent };